import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import ContactSection from '@/pages/home/components/ContactSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import AppSection from '@/pages/home/components/AppSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CardsSection from '@/pages/home/components/CardsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <MediaSection />
        <TopicsSection />
        <AppSection />
        <UpdatesSection />
        <AboutSection />
        <FeaturesSection />
        <FaqSection />
        <CardsSection />
        <CarouselSection />
        <IndexSection />
        <CommentsSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}